import React from 'react';
import RichText from '../../components/common/inputs/editableSelect/rich-text/rich-text';
import { CustomizeHeader } from './customizeHeader';
import '../../components/profile-info/user-profile.scss';

const PRESCRIPTION_TOGGLES = [
    ['visionInPrescription', 'Vision section show in prescription'],
    ['prescriptionRxTile', 'Prescription RX title show'],
    ['prescriptionDivider', 'Prescription divider show'],
    ['prescriptionHeaderInPrint', 'Prescription header show in print'],
    ['prescriptionFooterInPrint', 'Prescription footer show in print'],
    ['signatureWithImage', 'Signature field with image'],
    ['signatureWithoutImage', 'Signature field without image'],
    ['prescriptionBackgroundImage', 'Prescription background image'],
    ['isPhysicalExamShowInPrescription', 'Physical exam in prescription print'],
    ['pastMedicalHistoryInPrescription', 'Past medical history in prescription'],
    ['pastMedicationInPrescription', 'Past medication in prescription'],
    ['familyHistoryInPrescription', 'Family history in prescription'],
    ['surgicalHistoryInPrescription', 'Surgical history in prescription'],
    ['allergyHistoryInPrescription', 'Allergy history in prescription'],
    ['socilHistoryInPrescription', 'Social history in prescription'],
    ['diseaseActivityInPrescription', 'Disease activity scores in prescription'],
    ['hideOnExamName', 'Hide on Exam Name in Print'],
];

const PrescriptionSettingsTab = ({
    prescriptionSettingShowInfo,
    prescriptionSettingSetInfoFun,
    handlePrescriptionSubmit,
    isLoading,
    prescriptionInfo,
    setPrescriptionInfo,
}) => {
    const set = prescriptionSettingSetInfoFun;
    const show = prescriptionSettingShowInfo;

    return (
        <div className="my-profile-layout prescription-settings-page">
            <div className="basic-info profile-panel prescription-settings-panel mb-2">
                <div className="profile-panel__toolbar">
                    <div>
                        <h2 className="profile-panel__title">Prescription</h2>
                        <p className="profile-panel__subtitle">Print layout, typography, and default text for prescriptions.</p>
                    </div>
                    <button type="button" className="btn save-button" onClick={() => handlePrescriptionSubmit()}>
                        Save changes
                        {isLoading && (
                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />
                        )}
                    </button>
                </div>

                <h3 className="prescription-settings__section-title">Display &amp; print</h3>
                <div className="prescription-toggle-grid">
                    {PRESCRIPTION_TOGGLES.map(([key, label]) => (
                        <div
                            key={key}
                            className="prescription-toggle-row"
                            onClick={() => set(key, !show?.[key])}
                        >
                            <input checked={show?.[key] || false} type="checkbox" tabIndex={-1} />
                            <label>{label}</label>
                        </div>
                    ))}
                </div>

                <h3 className="prescription-settings__section-title">Layout &amp; sizing</h3>
                <div className="prescription-settings__layout-split">
                    <div className="prescription-settings__layout-col profile-fields prescription-settings__fields">
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Patient details position</label>
                            <div className="profile-field__control">
                                <select
                                    className="form-control input"
                                    onChange={(e) => set('prescriptionNamePosition', e.target.value)}
                                    value={show?.prescriptionNamePosition}
                                >
                                    <option value="1">Details on top</option>
                                    <option value="2">Details on left</option>
                                    <option value="3">Customize details on top</option>
                                </select>
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Default font size (pt)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionDefaultFontSize}
                                    type="number"
                                    onChange={(e) => set('prescriptionDefaultFontSize', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Medicine font size (pt)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.medicineFontSize}
                                    type="number"
                                    onChange={(e) => set('medicineFontSize', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Advice font size (pt)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionAdviceFontSize || ''}
                                    type="number"
                                    onChange={(e) => set('prescriptionAdviceFontSize', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Header height (px)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionHeaderHeight}
                                    type="number"
                                    onChange={(e) => set('prescriptionHeaderHeight', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Body height (px)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionBodyHeight}
                                    type="number"
                                    onChange={(e) => set('prescriptionBodyHeight', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="prescription-settings__layout-col profile-fields prescription-settings__fields">
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Body left padding (px)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionBodyLeftPadding}
                                    type="number"
                                    onChange={(e) => set('prescriptionBodyLeftPadding', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Margin (CSS, e.g. 5px 5px 5px 5px)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionMargin}
                                    type="text"
                                    onChange={(e) => set('prescriptionMargin', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Medicine section design</label>
                            <div className="profile-field__control">
                                <select
                                    className="form-control input"
                                    onChange={(e) => set('medicineSectionDesign', e.target.value)}
                                    value={show?.medicineSectionDesign}
                                >
                                    <option value="1">Design 1</option>
                                    <option value="2">Design 2</option>
                                </select>
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Body left section width (%)</label>
                            <div className="profile-field__control">
                                <input
                                    className="form-control input"
                                    value={show?.prescriptionBodyLeftSectionWidth}
                                    type="number"
                                    onChange={(e) => set('prescriptionBodyLeftSectionWidth', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Header background</label>
                            <div className="profile-field__control prescription-settings__color">
                                <input
                                    value={show?.headerBackgroundColor}
                                    type="color"
                                    onChange={(e) => set('headerBackgroundColor', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="profile-field profile-field--row mb-2">
                            <label className="profile-field__label form-label">Footer background</label>
                            <div className="profile-field__control prescription-settings__color">
                                <input
                                    value={show?.footerBackgroundColor}
                                    type="color"
                                    onChange={(e) => set('footerBackgroundColor', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <h3 className="prescription-settings__section-title">Notes</h3>
                <div className="profile-fields">
                    <div className="profile-field mb-2">
                        <label className="profile-field__label form-label">Next visit instructions</label>
                        <textarea
                            className="w-100"
                            rows={5}
                            value={show?.nextVisitInstructions}
                            onChange={(e) => set('nextVisitInstructions', e.target.value)}
                        />
                    </div>
                    <div className="profile-field mb-2">
                        <label className="profile-field__label form-label">Referral notes</label>
                        <textarea
                            className="w-100"
                            rows={5}
                            value={show?.referralNotes}
                            onChange={(e) => set('referralNotes', e.target.value)}
                        />
                    </div>
                </div>

                <div className="prescription-toggle-row mb-2" onClick={() => set('showDiscountNote', !show?.showDiscountNote)}>
                    <input checked={show?.showDiscountNote || false} type="checkbox" tabIndex={-1} />
                    <label>Show discount note</label>
                </div>
                <div className="profile-field mb-2">
                    <label className="profile-field__label form-label">Discount note</label>
                    <textarea
                        className="w-100"
                        rows={4}
                        value={show?.discountNote || ''}
                        onChange={(e) => set('discountNote', e.target.value)}
                    />
                </div>
                <div className="profile-field mb-0">
                    <label className="profile-field__label form-label">Signature note</label>
                    <textarea
                        className="w-100"
                        rows={4}
                        value={show?.signatureNote || ''}
                        onChange={(e) => set('signatureNote', e.target.value)}
                    />
                </div>
            </div>

            <div className="basic-info profile-panel prescription-settings-panel mb-2">
                <h3 className="prescription-settings__card-title">Patient block layout</h3>
                <CustomizeHeader
                    prescriptionSettingShowInfo={prescriptionSettingShowInfo}
                    prescriptionSettingSetInfoFun={prescriptionSettingSetInfoFun}
                />
            </div>

            <div className="basic-info profile-panel prescription-settings-panel mb-2">
                <h3 className="prescription-settings__card-title">Prescription header (rich text)</h3>
                <RichText
                    info={prescriptionInfo}
                    keyName="prescriptionHeader"
                    handleFormValues={(val, key) => {
                        prescriptionSettingSetInfoFun(key, val);
                        setPrescriptionInfo({ ...prescriptionInfo, [key]: val });
                    }}
                />
            </div>

            <div className="basic-info profile-panel prescription-settings-panel mb-2">
                <h3 className="prescription-settings__card-title">Prescription footer (rich text)</h3>
                <RichText
                    info={prescriptionInfo}
                    keyName="prescriptionFooter"
                    handleFormValues={(val, key) => {
                        prescriptionSettingSetInfoFun(key, val);
                        setPrescriptionInfo({ ...prescriptionInfo, [key]: val });
                    }}
                />
            </div>
        </div>
    );
};

export default PrescriptionSettingsTab;
